import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
})
export class TimeInputComponent implements OnInit {
  drivingTime: string;

  @Input() selectedValue: string;
  @Input() labelToDisplay: string;
  @Input() placeholderToDisplay: string;
  @Input() unit: string;
  @Input() minTime: string;
  @Output() selectedValueChange = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  valueChange() {
    if (this.lowerThanMinTime()) {
      this.selectedValue = this.minTime;
    }
    this.selectedValueChange.emit(this.selectedValue);
  }

  lowerThanMinTime() {
    return this.selectedValue < this.minTime;
  }

  valueDefault() {
    if (this.minTime) {
      if (!/\d\d:\d\d/.test(this.selectedValue)) {
        this.selectedValue = this.minTime;
        this.selectedValueChange.emit(this.minTime);
      }
    } else {
      if (this.selectedValue === '__:__') {
        this.selectedValueChange.emit(null);
      }
    }
  }
}
